export default {
  All: 'all',
  User: 'user',
  Job: 'job',
  Asset: 'asset',
  Requisition: 'requisition',
  RFQ: 'rfq',
  Order: 'order',
}
